import { render, staticRenderFns } from "./CoinInformationCard.vue?vue&type=template&id=5e0ba183&scoped=true&"
import script from "./CoinInformationCard.vue?vue&type=script&lang=ts&"
export * from "./CoinInformationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ba183",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
